// useBookingDraft — auto-saves the renter's in-progress checkout to the backend
// on a 700 ms debounce. Uses a module-level timer so React StrictMode's
// double-mount in dev doesn't clear the in-flight save.
import { useCallback } from "react";
import axios from "axios";
import { API, useAuth } from "../auth/AuthContext";

const DEBOUNCE_MS = 700;
let _timer = null;
let _lastKey = "";

async function _doSave(draft) {
  try { await axios.post(`${API}/bookings/draft`, draft, { withCredentials: true }); }
  catch (e) { /* best-effort, swallow */ }
}

export function useBookingDraft() {
  const { user } = useAuth();

  const saveDraft = useCallback((draft) => {
    if (!user) return;
    if (!draft?.vehicle_id || !draft?.start_date || !draft?.end_date) return;
    const key = JSON.stringify(draft);
    if (key === _lastKey) return;
    _lastKey = key;
    if (_timer) clearTimeout(_timer);
    _timer = setTimeout(() => _doSave(draft), DEBOUNCE_MS);
  }, [user]);

  const clearDraft = useCallback(async () => {
    if (!user) return;
    _lastKey = "__cleared__";
    if (_timer) { clearTimeout(_timer); _timer = null; }
    try { await axios.delete(`${API}/bookings/draft`, { withCredentials: true }); }
    catch (e) { /* silent */ }
  }, [user]);

  return { saveDraft, clearDraft };
}
